import React, { ChangeEvent } from 'react';

import { ReactComponent as SearchIcon } from '../../../../../resources/icons/search.svg';

import './support-chat-filter.scss';

type Props = {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

const SupportChatFilter = ({ value, onChange }: Props) => (
  <div className="support-chat-filter">
    <SearchIcon />
    <input value={value} onChange={onChange} data-testid="chat-filter" />
  </div>
);

export default SupportChatFilter;
